import { render, staticRenderFns } from "./InsuranceCompanyServicesTable.vue?vue&type=template&id=ec0106fe&"
import script from "./InsuranceCompanyServicesTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports